import { Injectable } from '@angular/core';

import { CollabConfiguration } from '../../models/collab-configuration.class';
import { ApiService } from '../api/api.service';
import { CollaborationService } from '../collaboration/collaboration.service';
import { CommonUtilsService } from '../commonutils/common-utils.service';
import { LocationsService } from '../locations/locations.service';
import { UtilsService } from '../utils/utils.service';

@Injectable({
    providedIn: 'root',
})
export class CommonCollaborationService {
    constructor(
        private _collabService: CollaborationService,
        public _utils: CommonUtilsService,
        public _taxilla: ApiService,
        private _libUtils: UtilsService,
        public _locations: LocationsService
    ) {}

    getCollabConfig = (that, callback?, assetId?: string, instanceId?: string) => {
        const data = {
            assetId: assetId || that.actualAssetId || that.assetData?.uid,
            instanceId: instanceId || that.instanceId,
        };
        this._collabService.getCollabConfig(data, {
            successCallback: res => {
                const collabConfig = CommonUtilsService.cloneObject(res.response);
                that.collabConfig = new CollabConfiguration(collabConfig);
                that.partnerFunctions = this.getAllPartnerFunctions(collabConfig);
                callback && callback(that.collabConfig, that.partnerFunctions);
            },
            failureCallback: res => {
                this._libUtils.alertError(res?.msg || 'There was a problem getting collaboration configuration.');
            },
        });
    };

    getAllPartnerFunctions = collabConfig => {
        const partnerFunctions = [];
        collabConfig?.isEnabled &&
            collabConfig?.partnerAppSettings.forEach(setting => {
                setting.isEnabled && setting.partnerFunction && partnerFunctions.push(setting.partnerFunction);
            });
        return partnerFunctions;
    };
}
